export default __webpack_public_path__ + "static/media/logo.f9d1b92f.png";